module.exports = __webpack_public_path__ + "img/ecomedica.54ce6ff0.png";